import React from "react";
import useAuth from "../hooks/useAuth";
import { Redirect } from "@reach/router";
import { PRIVATE } from "../../../routes/private";
import { PUBLIC } from "../../../routes/public";

function withRedirectToPrivate<P, C extends React.ComponentType<P>>(
  WrappedComponent: C,
): C {
  return ((props: P) => {
    const auth = useAuth();

    if (auth.user !== null)
      return <Redirect from={PUBLIC} to={PRIVATE} noThrow />;
    // eslint-disable-next-line @typescript-eslint/ban-ts-comment
    // @ts-ignore
    return <WrappedComponent {...(props as P)} />;
  }) as C;
}

export default withRedirectToPrivate;
